module.exports = __webpack_public_path__ + "04_long_grey.c2eb1a9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/04_long_grey.png
// module id = y9J3
// module chunks = 0